import React from 'react';
import { TLoaderProps } from './types';
import { Spinner, CardLoader } from './components';
import { PageWrapper } from './styles';

export default function Loader(props: TLoaderProps) {
  const { type = 'spinner' } = props;

  if (type === 'page') {
    return (
      <PageWrapper>
        <Spinner />
      </PageWrapper>
    );
  }

  if (type === 'card') {
    return <CardLoader />;
  }

  return <Spinner />;
}
